'use strict';

function LoanOfferAdditionalInfo() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_LoanOfferReupController];

  this.successfulSubmissions = null;
  this.failedSubmissions = null;

  this.init = function () {
    this._super();
    this._editEmploymentForm = this.node.querySelector('#editEmploymentInfo');
    this._editHousingInfoForm = this.node.querySelector('#editHousingInfo');
    this._addInfoSubmitButton = this.node.querySelector('.js-reupPreapproval__primaryButton');

    this._addInfoSubmitButton.addEventListener('click', this._onClickContinue.bind(this));

    this._editEmploymentFormCallback = this.presenter.addCallbackToAction('account.edit_employment_info', $.proxy(this._onEditAnyForm, this));

    this._editHousingFormCallback = this.presenter.addCallbackToAction('account.edit_housing_info', $.proxy(this._onEditAnyForm, this));
  };

  this.initAllReady = function () {
    this._super();
    this.analytics.pushEvent('virtual-page-view');
    var analyticsData = this.analytics.constructData('Loan Offer Refresh Started');
    var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
    analyticsRequest.send();
  };

  this.initPage = function () {
    this._super();

    this.node.removeClass('reupPreapproval--loading');
  };

  this._goToNextStep = function () {
    this._navTray = $('#tray-navigation').mogo();
    var currentIndex = this._navTray.getSelectedIndex();
    this._navTray.setCompleted(currentIndex);
    this._navTray.goToNextStep();
  };

  this._onClickContinue = function (evt) {
    evt.preventDefault();

    this.successfulSubmissions = 0;
    this.failedSubmissions = 0;

    // Submit forms only when there are no FE validation errors present.
    if (this._editEmploymentForm.mogo()._resultObj.count === 0 && this._editHousingInfoForm.mogo()._resultObj.count === 0) {
      // this._addInfoSubmitButton.mogo().setDisabledLoadState();
      if (this._editEmploymentForm.length) {
        $(this._editEmploymentForm).submit();
      }
      if (this._editHousingInfoForm.length) {
        $(this._editHousingInfoForm).submit();
      }
    }
  };

  this._onEditAnyForm = function (data, response) {
    // this._addInfoSubmitButton.mogo().removeDisabledLoadState();

    // Note: _EditEmployment.js & _EditHousing.js are handling the form submission details.
    if (response === 200) {
      this.successfulSubmissions++;
    } else {
      this.failedSubmissions++;
    }

    if (this.failedSubmissions === 0 && this.successfulSubmissions === 2) {
      this.analytics.pushEvent('form-submit', {
        FormID: ['Money-Form submission-Additional Information-null-Form']
      });
      this._goToNextStep();
    }
  };

  this.destroy = function () {
    this._addInfoSubmitButton.removeEventListener('click', this._onClickContinue);

    if (this._editEmploymentFormCallback) {
      this.presenter.removeCallbackFromAction('account.edit_employment_info', this._editEmploymentFormCallback);
    }
    if (this._editHousingFormCallback) {
      this.presenter.removeCallbackFromAction('account.edit_housing_info', this._editHousingFormCallback);
    }

    this._super();
  };
}